<template>
  <div
    id="search_results"
    class="container"
  >
    <div class="section__group col-md-12 mb-4">
        <p class="message-small">The number of bookings shown is limited to 100. Refine your search criteria to reduce the number of bookings shown.</p>
      <table-component
        :data="filteredSearchResults"
        :show-caption="false"
        sort-by="bookingDate"
        sort-order="desc"
        table-class="table table-striped table-bordered table-clickable table-results"
        thead-class="table-header-sort"
        filter-input-class="form-group form-control col-md-4"
        @rowClick="viewBooking"
      >
        <!--{{ bookingResults }}-->
        <table-column
          show="bookingReference"
          label="Reference"
        />
        <table-column label="First Name">
           <template slot-scope="row">
            {{ row.firstName }}
          </template>
        </table-column>
        <table-column label="Surname">
          <template slot-scope="row">
            {{ row.lastName }}
          </template>
        </table-column>
        <table-column label="Registration">
          <template slot-scope="row">
            {{ row.registration }}
          </template>
        </table-column>
        <table-column
          label="Booking Date"
          show="bookingDate"
        >
          <template slot-scope="row">
            {{ localDateTime(row.bookingDate) }}
          </template>
        </table-column>
        <table-column
          label="Arrival"
          show="entryDate"
          class="word-break-none"
        >
          <template slot-scope="row">
            {{ localDateTime(row.entryDate) }}
          </template>
        </table-column>
        <table-column
          :formatter="dateFormatter"
          show="exitDate"
          label="Departure"
        >
          <template slot-scope="row">
            {{ localDateTime(row.exitDate) }}
          </template>
        </table-column>
        <table-column
          label="Amount"
          class="word-break-none"
          show="totalPrice"
        >
          <template slot-scope="row">
            <span v-if="userCanSeeFinancialData"> {{ $n(row.totalPrice , 'currency', languageCode(row.airportId)) }} </span>
          </template>
        </table-column>
        <table-column
          label="Status"
        >
          <template slot-scope="row">
            <span v-if="row.status === row.subStatus">{{ row.status }}</span>
            <span v-else>{{ row.status }} ({{ row.subStatus }})</span>
          </template>
        </table-column>
        <table-column
          :sortable="false"
          :filterable="false"
          label="Actions"
        >
          <template slot-scope="row">
            <a>
              View
            </a>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'BookingSearch',
    computed: {
        ...mapGetters({
            userCanSeeFinancialData: 'auth/userCanSeeFinancialData'
        }),
        filteredSearchResults () {
            return this.$store.state.booking.bookingResults
        }
    },
    methods: {
        moment (arg) {
            return moment(arg)
        },
        viewBooking: function (row) {
            this.$store.dispatch('setSelectedAirportId', parseInt(row.data.airportId))
            this.$router.push({ path: `/booking/${row.data.id}` })
        },
        dateFormatter (value, rowProperties) {
            return moment(value).utc().format('DD/MM/YYYY HH:mm')
        },
        languageCode (airportId) {
            var code = this.$store.getters['getLanguageCode']({
                identifier: airportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        },
        localDateTime (dateTime) {
            var momentDateTime = moment.utc(dateTime).format('MM DD YYYY HH:mm:ss')
            var localDateTime = moment(momentDateTime).local().format('DD/MM/YYYY')

            return localDateTime
        }
    }
}
</script>
